import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";
import { useReveal } from "@/lib/useReveal";
import SectionLabel from "./SectionLabel";

export default function Problem() {
  const { t } = useI18n();
  const [ref, visible] = useReveal();

  return (
    <section id="problem" data-testid="problem-section" className="relative py-20 md:py-32">
      <div className="container-px mx-auto max-w-7xl">
        <SectionLabel>{t.problem.label}</SectionLabel>
        <motion.h2
          ref={ref}
          initial={{ opacity: 0, y: 18 }}
          animate={visible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mt-6 font-display font-bold text-ink text-balance leading-[1.05]
                     text-3xl sm:text-5xl lg:text-6xl max-w-3xl"
        >
          {t.problem.title}
        </motion.h2>
        <p className="mt-4 text-ink/60 max-w-xl">{t.problem.subtitle}</p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-px bg-line rounded-2xl overflow-hidden hairline">
          {t.problem.items.map((it, i) => (
            <motion.div
              key={it.k}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-bg p-7 md:p-8 relative group hover:bg-surface transition-colors"
              data-testid={`problem-item-${i}`}
            >
              <div className="flex items-baseline gap-3">
                <span className="mono-num text-danger text-sm">{it.k}</span>
                <span className="h-px flex-1 bg-line group-hover:bg-danger/40 transition-colors" />
              </div>
              <h3 className="font-display text-ink text-2xl font-semibold mt-5">{it.t}</h3>
              <p className="text-ink/60 text-sm mt-3 leading-relaxed">{it.d}</p>
              {/* progress bar visualizing damage */}
              <div className="mt-6 h-1 w-full rounded-full bg-surface overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: `${(i + 1) * 30}%` }}
                  viewport={{ once: true }}
                  transition={{ duration: 1, delay: 0.3 + i * 0.1 }}
                  className="h-full bg-danger"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
